import {load} from './common'

export function loadUsers() {
    return load('users')
}
export function loadRole() {
    return load('role')
}

export function selectUser(user) {
  return {
    type: 'user select',
    data: user
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/actions/user.js
 **/